import React from 'react'
import styles from './NavbarShell.module.scss'

interface NavbarShellProps {
  start: React.ReactNode
  center: React.ReactNode
  end: React.ReactNode
}

export const NavbarShell: React.FC<NavbarShellProps> = ({ start, center, end }) => (
  <header className={styles.navbar}>
    <nav className={styles.inner}>
      <div className={styles.start}>{start}</div>
      <div className={styles.center}>{center}</div>
      <div className={styles.end}>{end}</div>
    </nav>
  </header>
)

export const NavbarCtaDesktop: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.ctaDesktop}>{children}</div>
)
